import { useEffect, useState } from 'react';
import { useErrorStore } from '../../../../store/models';

function usePhoneVerificationError () {
    const errStore = useErrorStore();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (errStore.errors) {
            setErrors(errStore.errors);
        }
    // eslint-disable-next-line
    }, [
        errStore.observed.errors.sendPhoneNumberVerificationCode,
        errStore.observed.errors.updatePhoneNumber
    ]);

    return {
        errors,
    };
}

export default usePhoneVerificationError;
